<script>

    import {closeEditDetailsHalfScreen, editDetailsHalfScreen, openEditDetailsHalfScreen} from "./details-store.js";
    import ModsSelector from "../components/ModsSelector.svelte";
    import {publishConfigStore} from "../core/app-store.js";
    import AddToCartButton from "./AddToCartButton.svelte";
    import {addToCart} from "../cart/cart-store.js";
    import {getPriceWithMods} from "./details.js";
    import {onDestroy} from "svelte";
    import CartPreview from "./CartPreview.svelte";
    import {blurBackground, unblurBackground} from "../core/utils.js";
    import {eventBus} from "../core/event-bus-store.js";
    import {createEventDispatcher} from "svelte";
    import {t} from "../core/i18n/language-store.js";
    const dispatch = createEventDispatcher();

    let price = {};

    const storeSubscriptions = [
        editDetailsHalfScreen.subscribe(x => {
            if (x.opened) {
                price = getPriceWithMods(x.record);
                blurBackground();
            }
            else {
                unblurBackground();
            }
        })
    ];

    onDestroy(() => {

        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }

        unblurBackground();
    });

    function close () {
        closeEditDetailsHalfScreen();
    }

    function modsChangeHandler (record) {
        price = getPriceWithMods(record);
    }

    function addToCartHandler(record) {
        addToCart(record, {price: price.totalPrice, weight: price.selectedVariant?.weight}, price.selectedVariantIdx, price.selectedMods);
        closeEditDetailsHalfScreen();
    }

    function addMoreHandler(record) {

        if (record?.prices?.length > 1 || record?.mods?.length > 0) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'addItems'}}]);
        }
        else {
            dispatch('addToCart', {record});
        }
    }

</script>

<style>
    :root {
        --hafl-screen-top: 40vh;
    }
    .close-backdrop {
        background: var(--backdrop-color);
        display: block;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
    }
    .edit-details-block {

        top: var(--hafl-screen-top);
        z-index: 1001;
        border-top-left-radius: 2rem;
        border-top-right-radius: 2rem;

        position: fixed;
        width: 100vw;
        background: var(--bg-color);
        bottom: 0;

        box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.15);
    }
    .edit-details-block-content {
        padding: 0 1.25rem 1.25rem 1.25rem;
    }
    .edit-details-block-content.selector-block {
        padding-bottom: 50px;
        padding-top: 25px;
    }
    .mb-175 {
        margin-bottom: 1.75rem;
    }
    .fade-out-block {
        position: relative;
        pointer-events: none;
        margin-bottom: -50px;
        margin-top: -25px;
        height: 50px;
        background: linear-gradient(180deg, var(--bg-color), transparent);
    }
    .fade-in-block {
        pointer-events: none;
        margin-top: -50px;
        height: 50px;
        background: linear-gradient(0deg, var(--bg-color), transparent);
    }
    .footer {
        padding-top: .5rem;
    }
    .button {
        display: flex;
        justify-content: center;
        gap: .25em;
        border: none;
        border-radius: 1.75rem;
        padding: .9rem 1.25rem;
        width: 100%;
        font-size: var(--fs-100);
        font-family: inherit;
        color: var(--price-item-font-color);
        background-color: var(--price-item-bg-color);
        box-shadow: 0 6px 4px 0 rgb(0 0 0 / 10%);
        transition: background-color .2s ease, transform .1s ease-in;
    }
    @media (min-width: 524px) {
        .edit-details-container {
            width: 100vw;
            height: 100vh;
            display: flex;
            justify-content: center;
            position: absolute;
            z-index: 1000;
        }
        .close-backdrop {
            display: block;
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
        .close-button {
            position: fixed;
            top: 0;
            right: 0;
            z-index: 10;
            border-bottom-right-radius: 1.5rem;
            font-size: 1.25rem;
            padding: 1.25rem 1.25rem 1.25rem 1.5rem;
            line-height: 1;
            cursor: pointer;
        }
        .edit-details-block {
            max-width: 500px;
            box-shadow: 0 10px 24px 0 rgba(0, 0, 0, .15);
            margin-top: 5rem;
            margin-bottom: 2rem;
            border-radius: 2rem;
            max-height: calc(100vh - 10rem);
            min-height: unset;
        }
    }
    @media (max-width: 524px) {
        .close-button {
            position: fixed;
            right: 0;
            z-index: 10000;
            background: var(--bg-color);
            border-bottom-left-radius: 2rem;
            border-top-right-radius: 2rem;
            padding: 1.5rem 1.25rem 1rem 1.5rem;
            font-size: 1.25rem;
            line-height: 1;
            top: var(--hafl-screen-top);
            opacity: 0;
            animation: close-button-appears .2s ease-out .2s forwards;
        }
    }
    @keyframes close-button-appears {
        from {
            opacity: 0;
        }
        to {
            opacity: .8;
        }
    }
</style>

{#if ($editDetailsHalfScreen.opened)}

    <div class="edit-details-container">

        <div class="close-backdrop fade-in-animation" on:click={close}></div>

        <!-- CLOSE BUTTON -->
        <div class="close-button pointer" on:click={close}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Cross"><path d="M20 20L4 4m16 0L4 20"/></svg>
        </div>

        <div class="edit-details-block flex-vertical slide-up-animation layer-details">

            <div class="edit-details-block-content">
                <h2 class="fs-110 wrap-anywhere" style="padding: 0;">{ $editDetailsHalfScreen.record.name }</h2>
            </div>

            <!-- VARIANTS AND MODIFICATORS -->
            {#if ($editDetailsHalfScreen.showModsSelector)}
                <div class="fade-out-block"></div>

                <div class="edit-details-block-content selector-block flex-fill scroll-y">
                    <ModsSelector prices={$editDetailsHalfScreen.record?.prices}
                                  mods={$editDetailsHalfScreen.record?.mods}
                                  currency={$publishConfigStore.currency}
                                  on:changed={() => modsChangeHandler($editDetailsHalfScreen.record)}>
                    </ModsSelector>
                </div>

                <div class="fade-in-block"></div>
            {/if}

            <!-- ADD TO CART BUTTON -->
            {#if ($editDetailsHalfScreen.showAddButton)}
                <div class="edit-details-block-content footer">
                    <AddToCartButton publishConfig={$publishConfigStore}
                                     price={price}
                                     on:clicked={() => addToCartHandler($editDetailsHalfScreen.record)}>
                    </AddToCartButton>
                </div>
            {/if}

            <!-- CART PREVIEW -->
            {#if ($editDetailsHalfScreen.showCartPreview)}
                <div class="edit-details-block-content scroll-y mb-175 flex-fill">
                    <CartPreview record={$editDetailsHalfScreen.record}
                                 price={price}
                                 publishConfig={$publishConfigStore}>
                    </CartPreview>
                </div>

                <div class="edit-details-block-content footer">
                    <button class="button" on:click={() => { addMoreHandler($editDetailsHalfScreen.record) }}>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="3" y1="10.5" x2="18" y2="10.5" stroke="currentColor"/>
                            <line x1="10.5" y1="18" x2="10.5" y2="3" stroke="currentColor"/>
                        </svg>

                        {$t('addToCart.add')}
                    </button>
                </div>
            {/if}

        </div>
    </div>

{/if}
